<template>
    <div class="billing-address" v-if="!sameAsShippingAddress">
        <div class="billing-address__checkbox-container">
            <CieloCheckBoxV2
                class="justify-content-start"
                v-model="billingAddressTypeCheckbox"
                :clickable-slot="true"
                :text-aria="$ml.get('billingAddressTypeCheckbox')"
            >
                <span v-text="$ml.get('billingAddressTypeCheckbox')" />
            </CieloCheckBoxV2>
            <InfoTooltip
                :items="['billingAddressTypeTooltip']"
                :orientation="renderMobile() ? 'left' : 'top'"
                icon-color="gray"
            />
        </div>

        <div class="billing-address__address-container">
            <Address
                :zip-code.sync="zipCode"
                :street.sync="street"
                :address-line2.sync="addressLine2"
                :number.sync="number"
                :complement.sync="complement"
                :district.sync="district"
                :city.sync="city"
                :state.sync="state"

                :disable-street="disableStreet"
                :disable-district="disableDistrict"
                :disable-city="disableCity"
                :disable-state="disableState"

                :address-errors.sync="innerAddressErrors"

                :show-short-form="true"

                @postalCodeFetched="onZipCodeFetched"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    import { attr_accessor } from '@/services/VuexAcessor';
    import { isMobile } from '@/helpers/isMobile';
    
    import Address from '@/components/Address';
	import CieloCheckBoxV2 from '@/components/ClickToPay/template/CieloCheckBoxV2';
    import InfoTooltip from '@/components/InfoTooltip';

    export default {
        components: {
            Address,
            CieloCheckBoxV2,
            InfoTooltip
        },

        data() {
            return {
                innerAddressErrors: {},
                billingAddressTypeCheckbox: false,
            };
        },

        mounted() {
            this.billingAddressTypeCheckbox = !this.isNational;
            this.$emit('update:addressErrors', this.innerAddressErrors);
        },

        computed: {
            ...mapGetters({
                sameAsShippingAddress: 'billingAddress/getSameAsShippingAddress',
                isNational: 'billingAddress/getIsNational'
            }),

            disableStreet: self => false,
            disableDistrict: self => false,
            disableCity: self => self.fetchedFields.includes('city'),
            disableState: self => self.fetchedFields.includes('state'),

            /**
             * Dados a serem sincronizados com o storage
             */
            billingAddressType: attr_accessor(state => state.billingAddress.Type, 'billingAddress/setType'),
            zipCode: attr_accessor(state => state.billingAddress.ZipCode, 'billingAddress/setZipCode'),
            street: attr_accessor(state => state.billingAddress.Street, 'billingAddress/setStreet'),
            addressLine2: attr_accessor(state => state.billingAddress.AddressLine2, 'billingAddress/setAddressLine2'),
            number: attr_accessor(state => state.billingAddress.Number, 'billingAddress/setNumber'),
            complement: attr_accessor(state => state.billingAddress.Complement, 'billingAddress/setComplement'),
            district: attr_accessor(state => state.billingAddress.District, 'billingAddress/setDistrict'),
            city: attr_accessor(state => state.billingAddress.City, 'billingAddress/setCity'),
            state: attr_accessor(state => state.billingAddress.State, 'billingAddress/setState'),

            fetchedFields:{
                get: self => self.$store.state.billingAddress.FetchedFields
            },
        },

        watch: {
            billingAddressTypeCheckbox(newVal) {
                const type = newVal ? 'foreign' : 'national';
                this.$store.commit('billingAddress/setType', type);
            },
        },

        methods: {
            onZipCodeFetched(response) {
                this.$store.commit('billingAddress/setFromRequest', response.fields);
            },

            renderMobile() {
                return isMobile();
            },
        },

        props: {
            addressErrors: {
                type: Object,
                default() {
                    return {};
                }
            },
        }
    };
</script>

<style lang="scss" scoped>
    .billing-address {
        margin-top: 20px;

        &__checkbox-container {
            display: flex;
            gap: 8px;
            margin-bottom: 20px;
        }
    }

</style>
